import React from 'react';

import { formatBackorderMessage } from './storeLogic/storeStateManager';

function CheckoutSummaryItem({item}) {
  const formattedSubtotal = parseFloat(item.subtotal).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const formattedQuantity = parseInt(item.quantity).toLocaleString('en-US');
  backorderMessage = formatBackorderMessage(item.quantity, item.productDetails.quantity, item.productDetails.backordering, item.productDetails.type);

  return (
    <tr key={item.id}>
      <th>
        {item.productDetails.title}
        {item.quantity > 1 && ` x ${formattedQuantity}`}
        {backorderMessage !== null &&
          <div className="backorder">{backorderMessage}</div>
        }
      </th>
      <td>{formattedSubtotal}</td>
    </tr>
  )
}

export default CheckoutSummaryItem